import * as z from "zod";

export const schema = z.object({
    email: z.string().min(1, "forms.general-validation.email_required").email("forms.general-validation.email_invalid"),
    nickname: z.string().min(1, "forms.general-validation.nickname_required"),
    terms_agreement: z.boolean().optional(),
});

export type RegistrationFormData = z.infer<typeof schema>;
